import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "./AuthContext";

const Ctx = createContext({ content: {}, c: (k, d) => d, reload: () => {} });
const abs = (u) => (u && u.startsWith("/api/") ? `${API.replace(/\/api$/, "")}${u}` : u);

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [overrides, setOverrides] = useState({});
  useEffect(() => {
    if (!window.location.search.includes("preview=1")) return;
    const h = (e) => { if (e.data?.type === "rl-preview") setOverrides(e.data.overrides || {}); };
    window.addEventListener("message", h); return () => window.removeEventListener("message", h);
  }, []);
  const reload = useCallback(() => axios.get(`${API}/site/content`).then(r => setContent(r.data)).catch(() => {}), []);
  useEffect(() => { reload(); }, [reload]);
  const merged = { ...content, ...overrides };
  useEffect(() => {
    const root = document.documentElement;
    const content = merged;
    if (content["brand.color_primary"]) root.style.setProperty("--rl-primary", content["brand.color_primary"]);
    if (content["brand.color_accent"]) root.style.setProperty("--rl-accent", content["brand.color_accent"]);
    if (content["brand.color_success"]) root.style.setProperty("--rl-success", content["brand.color_success"]);
    if (content["brand.logo_mark"]) document.getElementById("root")?.style.setProperty("--rl-mark", `url('${abs(content["brand.logo_mark"])}')`);
  }, [content, overrides]);
  const c = (key, fallback = "") => { const v = merged[key]; return v === undefined || v === "" ? fallback : v; };
  const img = (key, fallback) => abs(c(key, fallback));
  return <Ctx.Provider value={{ content, c, img, reload }}>{children}</Ctx.Provider>;
}

export const useContent = () => useContext(Ctx);
